import React from 'react'

import Icon from 'components/Icon'
import Button from 'components/Button'

import classNames from 'helpers/css'

import styles from './index.module.scss'

const Pagination: React.FC<PaginationProps> = (props) => {
  const {
    setPage,
    page,
    className = '',
  } = props

  const changePage = (delta: number) => () => {
    setPage(page + delta >= 0 ? page + delta : page)
  }

  return (
    <div className={classNames(styles, 'projects-dropdown__for-consultants__pagination', className)}>
      <Button
        onClick={changePage(-1)}
        className={classNames(styles, 'projects-dropdown__for-consultants__pagination__button')}
      >
        <Icon name="angle-left" />
      </Button>

      <span className={classNames(styles, 'projects-dropdown__for-consultants__pagination__page')}>
        {page + 1}
      </span>

      <Button
        onClick={changePage(1)}
        className={classNames(styles, 'projects-dropdown__for-consultants__pagination__button')}
      >
        <Icon name="angle-right" />
      </Button>
    </div>
  )
}

type PaginationProps = {
  setPage: (page: number) => void
  page: number
  className?: string
}

export default Pagination
